import { useEffect, useRef } from 'react';

type Options = {
  autoStart?: boolean;
};
export function useInterval(
  callback: (v: number) => void,
  delay: number,
  opts?: Options,
) {
  const id = useRef<NodeJS.Timeout>();
  const counter = useRef(0);

  useEffect(() => {
    if (opts?.autoStart === false) return;
    return start();
  }, [opts?.autoStart]);

  function start() {
    id.current = setInterval(() => {
      callback(counter.current++);
    }, delay);
    return () => {
      clearInterval(id.current);
    };
  }
  function stop() {
    clearInterval(id.current);
  }

  return {
    start,
    stop,
    counter,
  };
}
